import { useLog } from '@/hooks/V3/useLog';
import { useAppSelector } from '@/redux/store';
import { deviceUuidState } from '@/store/atom';
import type { BlogPosting } from '@/types/discover';
import { useRecoilValue } from 'recoil';
import { DashboardCard } from '../card';
import { useBlogPreview } from '@/hooks/dashBoard/useBlogPreview';
import { useMembershipPreviewMode } from '@/components/membership/MembershipContentLock';

const BlogPreview = () => {
  const isPreviewMode = useMembershipPreviewMode();
  const { blogList } = useBlogPreview();

  const { UserNo } = useAppSelector((state) => state.user);
  const { setUserEventHistory } = useLog(UserNo);
  const deviceUuid = useRecoilValue(deviceUuidState);

  const handleBlogClick = (item: BlogPosting) => {
    setUserEventHistory({
      eventName: 'blog_article_click_web_dashboard',
      eventValue: item.Title,
      deviceUuid,
    });
  };

  return (
    <DashboardCard>
      <div className="text-gr-900 Body1S16">블로그</div>
      <div className="grid grid-cols-2 gap-[12px]">
        {blogList?.slice(0, 4).map((item) => (
          <a
            key={`${item.Title}-${item.ThmubnailUrl}`}
            href={item.Url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-[12px]  "
            data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
            onClick={() => handleBlogClick(item)}
          >
            <img
              src={item.ThmubnailUrl}
              alt="썸네일"
              className="min-h-[64px] max-w-[30%] rounded-[10px] object-cover"
              height={64}
              width={100}
            />
            <div className="flex flex-col">
              <span className="text-gr-600 Caption1M12">{item.CategoryPublicName}</span>
              <span className="line-clamp-2 text-gr-800 Body4S14">{item.Title}</span>
            </div>
          </a>
        ))}
      </div>
    </DashboardCard>
  );
};

export default BlogPreview;
